const notifications = ({ notifications }) => notifications.notifications;
const oldNotifications = ({ notifications }) => notifications.oldNotifications;

export {
    notifications,
    oldNotifications,
};
